(function (angular) {
    'use strict';

    angular
        .module('app', [
            'app.core',
            'app.auth',
            'app.roles',
            'app.login',
            'app.nav',
            'app.components',
            'app.header',
            'app.clientlist',
            'app.client',
            'app.crmsync',
            'app.templates',
            'app.secret',
            'app.server',
            'app.serverlist',
            'app.sendgrid',
            'app.footer',
            'app.oidcmanifest'
        ]);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.auth', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.client', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.clientlist', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.core', ['ngRoute', 'AdalAngular']);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.crmsync', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.footer', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.header', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.login', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.nav', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.oidcmanifest', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.roles', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.secret', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.sendgrid', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.server', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.serverlist', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.templates', []);

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.auth')
        .constant('ngAuthSettings', {
            apiServiceBaseUri: 'http://localhost:54565/'
        });

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.client')
        .controller('clientController', ClientController);

    ClientController.$inject = [
        '$scope',
        'datasource',
        'message',
        '$routeParams',
        '$location',
        'dataTransferService',
        'groupsService',
        'adalAuthenticationService'
    ];

    // eslint-disable-next-line sonarjs/cognitive-complexity
    function ClientController($scope, datasource, message, $routeParams,
        $location, dataTransferService, groupsService,
        adalAuthenticationService) {

        const CONNECTION_FAILED_MESSAGE = "Failed to connect to API.";

        var vm = this;

        vm.client = {};
        vm.clientName = '';

        vm.showAddressBar = showAddressBar;
        vm.toggleEditView = toggleEditView;
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.editServer = editCrmServer;
        vm.saveClient = saveClient;
        vm.deleteClient = deleteClient;
        vm.addService = addService;
        vm.addServer = addServer;
        vm.addNote = addNote;
        vm.listView = listView;
        vm.checkState = checkState;
        vm.getClient = getClient;
        vm.getTypes = getTypes;
        vm.getGroups = getGroups;
        vm.crmServers = crmServers;
        vm.resolveImageName = resolveImageName;

        vm.showbuttons = {
            add: false,
            edit: true
        };

        vm.clientId = ($routeParams.id) ? $routeParams.id : null;

        vm.message = message.show('Loading client', 'info');

        if (vm.clientId !== 'add') {
            vm.editView = false;
            vm.showDelete = true;
            getClient();

        } else {
            vm.editView = true;
            vm.showDelete = false;

            getAccounts();
        }

        vm.crmAccountSelected = crmAccountSelected;
        vm.clientTitle = clientTitle;

        getTypes();
        getGroups();

        function getClient() {
            vm.message = message.show('Loading client information', 'info');

            datasource
                .getClient(vm.clientId)
                .success(function (data) {
                    vm.client = angular.fromJson(data);

                    vm.showAddressBar();

                    vm.message = message.hide();
                })
                .error(function (error) {
                    var msg;

                    if (!error.message) {
                        msg = CONNECTION_FAILED_MESSAGE;
                    } else {
                        msg = 'Could not find client: ' + error.message;
                    }
                    vm.message = message.show(msg, 'error');
                });
        }

        function getTypes() {
            datasource
                .getTypes()
                .success(function (json) {
                    var data = angular.fromJson(json);

                    vm.servicetypes = data.servicetypes;
                    vm.schooltypes = data.schooltypes;

                    vm.client.type = vm.client.type || vm.schooltypes[0].id;
                })
                .error(function (error) {
                    var msg;

                    if (!error.message) {
                        msg = CONNECTION_FAILED_MESSAGE;
                    } else {
                        msg = 'Could not load types: ' + error.message;
                    }
                    vm.message = message.show(msg, 'error');

                    vm.client = null;
                });
        }

        function getGroups() {
            vm.groups = dataTransferService.getData('groups');

            if ((vm.groups || []).length > 0) {
                vm.message = message.show('Checking for updates', 'info');
            }

            datasource
                .getGroups()
                .success(function (data) {
                    vm.groups = angular.fromJson(data);

                    vm.message = message.hide();
                })
                .error(function (error) {
                    var msg;

                    if (!error.message) {
                        msg = CONNECTION_FAILED_MESSAGE;
                    } else {
                        msg = 'Could not load groupings: ' + error.message;
                    }
                    vm.message = message.show(msg, 'error');
                });
        }

        function getAccounts() {
            datasource
                .getUnallocatedAccounts()
                .success(function (json) {
                    var data = angular.fromJson(json);

                    vm.crmAccounts = data;
                })
                .error(function (error) {
                    var msg;

                    if (!error.message) {
                        msg = CONNECTION_FAILED_MESSAGE;
                    } else {
                        msg = 'Could not load accounts: ' + error.message;
                    }
                    vm.message = message.show(msg, 'error');

                    vm.crmAccounts = [];
                });
        }

        function resolveImageName(service) {
            if (vm.servicetypes == null) {
                return "none";
            }

            var type = vm.servicetypes.filter(function (t) {
                return t.id === service.type;
            })[0];

            if (type != null && type.imageName != null) {
                return type.imageName;
            }

            return "none";
        }

        function showAddressBar() {
            vm.addressBarShown = (function (address) {
                for (var member in address) {
                    if (address[member] !== null && address[member] !== '' && member !== 'name') {
                        return true;
                    }
                }
                return false;
            }(vm.client.address));
        }

        function cancel() {
            if (vm.clientId !== 'add') {
                vm.toggleEditView();
            } else {
                vm.listView();
            }
        }

        function deleteItem(item) {
            item.deleted = true;
        }

        function editCrmServer(id) {
            $location.path('server/' + id + '/' + vm.clientId).replace();
        }

        function toggleEditView() {
            vm.editView = !vm.editView;

            if (vm.editView) {
                vm.original = angular.copy(vm.client);
            } else {
                angular.copy(vm.original, vm.client);
                vm.setForDelete = false;
            }

            vm.showAddressBar();
        }

        function saveClient() {
            var index,
                len,
                server,
                service,
                note,
                err,
                toRemove,
                ipPattern;

            vm.client.address = vm.client.address || {};
            vm.client.notes = vm.client.notes || [];
            vm.client.servers = vm.client.servers || [];
            vm.client.services = vm.client.services || [];

            vm.client.requester = adalAuthenticationService.userInfo.userName;
            
            if (vm.clientId === 'add' && (!vm.client.clientCode || vm.client.clientCode === '')) {
                vm.message = message.show('Can not add a client without a client code. Use the CRM dropdown to select the correct client.', 'error');
                return false;
            }
            
            
            if (!vm.client.name || vm.client.name === '') {
                vm.message = message.show('Can not add a client without a name.', 'error');
                return false;
            }

            err = false;
            toRemove = [];
            ipPattern = new RegExp(/^\d{1,3}(\.\d{1,3}){3}$/);

            for (index = 0, len = vm.client.servers.length; index < len; index += 1) {
                server = vm.client.servers[index];

                if (server.add && (server.deleted || (
                                    server.name === '' &&
                                    server.password === '' &&
                                    server.username === '' &&
                                    server.domain === '' &&
                                    server.url === '' &&
                                    server.ip === ''))) {
                    toRemove.push(server.$$hashKey);

                } else if (server.name === '' || !server.name) {
                    if (server.deleted) {
                        server.name = 'tobedeleted';
                    } else {
                        vm.message = message.show('Can not add a server without a name.', 'error');
                        err = true;
                        break;
                    }

                } else if (server.ip && server.ip !== '' &&
                            ipPattern.test(server.ip) === false) {
                    vm.message = message.show('The IP Address ' +
                                    server.ip.replace(/'/g, '') + ' is not valid.', 'error');
                    err = true;
                    break;
                }
            }

            if (err) {
                return false;
            }

            vm.client.servers = removeUnUsed(toRemove, vm.client.servers);
            toRemove = [];

            for (index = 0, len = vm.client.services.length; index < len; index += 1) {
                service = vm.client.services[index];

                if (service.add && (service.deleted || (service.url === ''))) {
                    toRemove.push(service.$$hashKey);

                } else if (service.url === '' || !service.url) {
                    if (service.deleted) {
                        service.url = 'tobedeleted';
                    } else {
                        vm.message = message.show('Can not add a service without a  url.', 'error');
                        err = true;
                        break;
                    }

                }
            }

            if (err) {
                return false;
            }

            vm.client.services = removeUnUsed(toRemove, vm.client.services);
            toRemove = [];

            for (index = 0, len = vm.client.notes.length; index < len; index += 1) {
                note = vm.client.notes[index];

                if (note.add && (note.deleted || (note.type === '' && note.text === ''))) {
                    toRemove.push(note.$$hashKey);

                }else if (note.type === '' || !note.type) {
                    if (note.deleted) {
                        note.type = 'tobedeleted';
                    } else {
                        vm.message = message.show('Can not add a note without a title.', 'error');
                        err = true;
                        break;
                    }

                } else if (note.text === '' || !note.text) {
                    if (note.deleted) {
                        note.text = 'tobedeleted';
                    } else {
                        vm.message = message.show('Can not add a note without text.', 'error');
                        err = true;
                        break;
                    }
                }
            }

            if (err) {
                return false;
            }

            vm.client.notes = removeUnUsed(toRemove, vm.client.notes);
            toRemove = [];

            if (vm.clientId !== 'add') {

                datasource
                    .updateClient(vm.client)
                    .success(function (updatedClient) {
                        vm.client = updatedClient;

                        vm.message = message.show('Client updated', 'ok');

                        vm.editView = false;

                        cleanAdd ();
                    })
                    .error(function (error) {
                        var msg;

                        if (!error.message) {
                            msg = CONNECTION_FAILED_MESSAGE;
                        } else {
                            msg = 'Could not save client: ' + error.message;
                        }
                        vm.message = message.show(msg, 'error');
                    });

            } else {

                datasource
                    .addClient(vm.client)
                    .success(function (newClient) {
                        vm.client = newClient;
                        vm.clientId = newClient.Id;

                        vm.message = message.show('Client created', 'ok');

                        vm.editView = false;

                        cleanAdd ();
                    })
                    .error(function (error) {
                        var msg;

                        if (!error.message) {
                            msg = CONNECTION_FAILED_MESSAGE;
                        } else {
                            msg = 'Could not add client: ' + error.message;
                        }
                        vm.message = message.show(msg, 'error');
                    });
            }
        }

        function deleteClient() {

            if (vm.setForDelete === true) {

                datasource
                    .deleteClient(vm.clientId)
                    .success(function () {
                        vm.client.deleted = true;
                        vm.listView();
                    })
                    .error(function (error) {
                        var msg;

                        if (!error.message) {
                            msg = CONNECTION_FAILED_MESSAGE;
                        } else {
                            msg = 'Could not delete client: ' + error.message;
                        }
                        vm.message = message.show(msg, 'error');
                    });
            }
            else {
                vm.setForDelete = true;
            }
        }

        function addService() {
            vm.client.services = vm.client.services || [];
            vm.client.services.push({
                        type: vm.servicetypes[0].id || null,
                        url: '',
                        deleted: false,
                        add: true
                    });
        }

        function addServer() {
            vm.client.servers = vm.client.servers || [];
            vm.client.servers.push({
                        name: '',
                        url: null,
                        username: null,
                        password: null,
                        domain: null,
                        deleted: false,
                        add: true
                    });
        }

        function addNote() {
            vm.client.notes = vm.client.notes || [];
            vm.client.notes.push({
                        type: '',
                        text: '',
                        deleted: false,
                        add: true
                    });
        }

        function listView() {
            $location.url($location.path());
            $location.path('/clientlist/').replace();
        }

        function checkState(text) {
            return !(text === null || text === '')
        }

        function removeUnUsed(remove, removeFrom) {
            var index,
                iIndex,
                len,
                iLen;

            for (index = 0, len = remove.length; index < len; index += 1) {

                for (iIndex = 0, iLen = removeFrom.length; iIndex < iLen; iIndex += 1) {

                    if (removeFrom[iIndex].$$hashKey === remove[index]) {
                        removeFrom.splice(iIndex, 1);
                        break;
                    }
                }
            }
            return removeFrom;
        }

        function cleanAdd() {
            var index,
                len;

            for (index = 0, len = vm.client.servers.length; index < len; index += 1) {
                vm.client.servers[index].add = false;
            }

            for (index = 0, len = vm.client.services.length; index < len; index += 1) {
                vm.client.services[index].add = false;
            }

            for (index = 0, len = vm.client.notes.length; index < len; index += 1) {
                vm.client.notes[index].add = false;
            }
        }

        function crmAccountSelected() {
            var client = vm.crmAccounts.filter(function(a) {
                return a.clientCode === vm.client.clientCode;
            })[0];
            if (client) {
                vm.client.name = client.name;
            } else {
                vm.client.name = null;
            }
        }

        function clientTitle() {
            if (!vm.client.clientCode) {
                return vm.client.name || '';
            }

            return vm.client.name + ' [' + vm.client.clientCode + ']';
        }

        function crmServers() {
            if (!vm.client || !vm.client.crmServers) {
                return [];
            }

            return vm.client.crmServers;
        }
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.client')
        .filter('schoolType', SchoolType);

    function SchoolType () {
        return function (stype, scope) {
            if (stype) {
                var types,
                    schooltype,
                    len,
                    t;

                types = scope.vm.schooltypes;
                schooltype = 1;

                if (!types) {
                    return null;
                }

                for (t = 0, len = types.length; t < len; t += 1) {
                    if (types[t].id === stype) {
                        schooltype = types[t].name;
                    }
                }
                return schooltype;
            }
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.clientlist')
        .controller('clientlistController', ClientlistController);

    ClientlistController.$inject = [
        'datasource',
        'message',
        '$location',
        'dataTransferService',
        'groupsService'
        ];

    // eslint-disable-next-line sonarjs/cognitive-complexity
    function ClientlistController (datasource, message, $location,
                                    dataTransferService, groupsService) {

        var vm = this;

        vm.clientName = null;
        vm.clients = [];

        vm.message = message.show('Loading list of clients', 'info');

        vm.search = search;
        vm.startsWith = startsWith;
        vm.setLetter = setLetter;
        vm.showClient = showClient;
        vm.addClient = addClient;
        vm.noSearchResults = noSearchResults;
        vm.clearSearch = clearSearch;
        vm.setGroups = setGroups;
        vm.query = dataTransferService.getData('searchValue');
        vm.letter = dataTransferService.getData('letterValue') || '';

        vm.showbuttons = {
            add: true,
            edit: false
        };

        vm.alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g',
            'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p',
            'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

        init();

        function init() {
            datasource
                .getClients()
                .success(function (data) {
                    vm.clients = angular.fromJson(data);

                    vm.message = message.show(vm.clients.length + ' clients loaded.', 'ok');

                    vm.setGroups();
                })
                .error(function (error) {
                    var msg;

                    if (!error.message) {
                        msg = 'Failed to connect to API.';
                    } else {
                        msg = 'Unable to load list of clients: ' + error.message;
                    }
                    vm.message = message.show(msg, 'error');
                });
        }

        function search(client) {
            function checkValue(val) {
                val = val || '';
                return (angular.lowercase(val).indexOf(angular.lowercase(vm.query) || '') !== -1);
            }

            return checkValue(client.name) ||
                checkValue(client.grouping) ||
                checkValue(client.clientCode);
        }

        function startsWith(client) {
            if (vm.letter !== '') {
                return (angular.lowercase(client.name).indexOf(vm.letter) === 0);
            }
            return true;
        }

        function setLetter(letter) {
            vm.letter = (vm.letter === letter) ? '' : letter;
        }

        function showClient(id) {
            setSearch();
            $location.url($location.path());

            if (id) {
                $location.path('client/' + id).replace();

            } else if (vm.filteredClients.length > 0) {

                $location.path('client/' + vm.filteredClients[0].id).replace();
            }
        }

        function addClient() {
            setSearch();
            $location.url($location.path());
            $location.path('client/add').replace();
        }

        function noSearchResults() {
            if (vm.filteredClients === undefined || vm.clients.length === 0) {
                return false;
            }
            return ((vm.filteredClients).length === 0);
        }

        function clearSearch() {
            vm.query = '';
            vm.letter = '';
        }

        function setGroups() {
            var groups = groupsService.getGroups(vm.clients);
            dataTransferService.setData('groups', groups);
        }

        function setSearch() {
            dataTransferService.setData('letterValue', vm.letter);
            dataTransferService.setData('searchValue', vm.query);
        }
    }

}(angular));

(function(angular) {
    'use strict';

    angular
        .module('app.components')
        .controller('autoCompleteController', AutoCompleteController)
        .directive('autoComplete', AutoComplete);

    AutoCompleteController.$inject = ['$filter', '$scope', '$timeout'];

    // eslint-disable-next-line sonarjs/cognitive-complexity
    function AutoCompleteController($filter, $scope, $timeout) {
        var ctrl = this;

        ctrl.focused = false;
        ctrl.selected = null;
        ctrl.showHints = showHints;
        ctrl.chooseHint = chooseHint;
        ctrl.userAction = userAction;
        ctrl.setFocus = setFocus;

        function showHints() {
            var filteredLen;

            if (!ctrl.filteredHints) {
                return false;
            }
            filteredLen = ctrl.filteredHints.length;
            return (filteredLen < ctrl.hints.length && +
                ctrl.filteredHints[0] !== ctrl.autocomplete && filteredLen > 0) ? +
                true : false;
        }

        function chooseHint(chosenHint) {
            ctrl.selected = chosenHint;
            ctrl.autocomplete = ctrl.selected;
            ctrl.focused = false;
        }

        function userAction(keyEvent) {
            var key,
                index,
                len;

            ctrl.focused = true;

            key = typeof keyEvent.which === 'undefined' ? keyEvent.keyCode : keyEvent.which;
            index = ctrl.filteredHints.indexOf(ctrl.selected);
            len = ctrl.filteredHints.length - 1;

            if (key === 13 && len > 0) {
                if (index < 0) {
                    ctrl.selected = ctrl.filteredHints[0];
                }
                ctrl.autocomplete = ctrl.selected;
                ctrl.focused = false;
                keyEvent.preventDefault();

            } else if (key === 38) {
                if (index > 0) {
                    index -= 1;
                } else {
                    index = 0;
                }
                ctrl.selected = ctrl.filteredHints[index];
                keyEvent.preventDefault();

            } else if (key === 40) {
                if (index < len) {
                    index += 1;
                } else {
                    index = len;
                }
                ctrl.selected = ctrl.filteredHints[index];
                keyEvent.preventDefault();
            }
        }

        function setFocus(focus) {
            if (focus) {
                ctrl.focused = true;
            } else {
                $timeout(function () {
                    ctrl.focused = false;
                }, 200);
            }
        }

        $scope.$watchCollection('ctrl.autocomplete', function () {
            ctrl.filteredHints = $filter('filter')(ctrl.hints, ctrl.autocomplete);
            if (!ctrl.filteredHints) {
                return false;
            }
            if (ctrl.filteredHints.indexOf(ctrl.selected) < 0) {
                ctrl.selected = ctrl.filteredHints[0];
            }
        });
    }

    function AutoComplete() {
        return {
            restrict: 'E',
            scope: {
                hints: '=',
                autocomplete: '=value',
                placeholder: '@'
            },
            controller: 'autoCompleteController',
            controllerAs: 'ctrl',
            bindToController: true,
            templateUrl: 'autocomplete.htm'
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components')
        .directive('autofocus', AutoFocus);

    AutoFocus.$inject = ['$timeout'];

    function AutoFocus($timeout) {
        return {
            restrict: 'AC',
            link: function (scope, element) {
                scope.$watch('autofocus', function() {
                    $timeout(function() {
                        element[0].focus();
                        //element[0].select();
                    });
                });
            }
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components')
        .directive('ctrlC', CtrlC);

    function CtrlC() {
        return {
            restrict: 'C',
            scope: {},
            link: function (scope, elem) {
                var copyText,
                    successful,
                    message;

                copyText = document.querySelector('.ctrl-c-text');

                if (copyText) {
                    elem.bind('click', function () {

                        if (elem.attr('data-ctrlc')) {
                            copyText.value = elem.attr('data-ctrlc');
                        } else {
                            copyText.value = elem.text();
                        }
                        copyText.style.display = 'block';
                        copyText.select();

                        try {
                            successful = document.execCommand('copy');
                            message = successful ? 'successful' : 'unsuccessful';
                            console.log('Copying text command was ' + message);

                            elem.addClass('copied');

                            setTimeout(function () {
                                elem.removeClass('copied');
                            }, 1000);

                        } catch (err) {
                            console.log('Oops, unable to copy');
                        }

                        copyText.style.display = 'none';
                    });
                }
            }
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components')
        .service('dataTransferService', DataTransferService);

    function DataTransferService () {
        var LOCAL_DATA,
            setData,
            getData;

        LOCAL_DATA = {};

        setData = function (name, data) {
            LOCAL_DATA[name] = data;
        };

        getData = function (name) {
            if (!name) {
                return null;
            }
            return LOCAL_DATA[name];
        };

        return {
            getData: getData,
            setData: setData
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components')
        .directive('ngEnter', Enter);

    function Enter () {
        return function (scope, element, attrs) {
            element.bind('keydown keypress', function (event) {
                if (event.which === 13) {

                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components')
        .service('groupsService', GroupsService);

    function GroupsService() {

        var getGroups;

        getGroups = function (groupsFrom) {
            var groups,
                client,
                i;

            groups = [];

            for (i in groupsFrom) {
                client = groupsFrom[i];
                if (client.grouping && groups.indexOf(client.grouping) === -1) {
                    groups.push(client.grouping);
                }
            }

            return groups;
        };

        return {
            getGroups: getGroups
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components')
        .filter('isamsUrl', IsamsUrl);

    function IsamsUrl() {
        return function (url, item) {
            if (url) {
                var isamsUrl;

                isamsUrl = (!item.type || item.type === 1) ? true : false;

                if (!url.match(/(^|[^/])\/{1}([^/])+([^/]*)/g) && isamsUrl) {

                    if (url.charAt(url.length - 1) !== '/') {
                        url += '/';
                    }

                    return url + 'framework';
                }
            }

            return url;
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components')
        .service('message', Message);

    function Message() {

        function show(text, status) {
            var durationShown;

            durationShown = 2000;

            switch (status) {
                case 'ok':
                    durationShown = 750;
                    break;
                case 'info':
                    durationShown = 0;
                    break;
                case 'error':
                    durationShown = 2000;
                    break;
            }

            return {
                text: text,
                status: status,
                shown: true,
                duration: durationShown
            };
        }

        function hide() {
            return {
                shown: false
            };
        }

        return {
            show: show,
            hide: hide
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components')
        .directive('messageBar', MessageBar);

    MessageBar.$inject = ['$timeout'];

    function MessageBar($timeout) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                messagebar: '=values'
            },
            link: function(scope) {
                scope.$watch('messagebar', function (newValue) {
                    if (newValue) {
                        $timeout.cancel(scope.autoHide);

                        if (scope.messagebar.duration > 0) {
                            scope.autoHide = $timeout(function () {
                                scope.messagebar.shown = false;
                            }, scope.messagebar.duration);
                        }
                    } else {
                        $timeout.cancel(scope.autoHide);
                    }
                }, true);
            },
            templateUrl: 'messagebar.htm'
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components')
        .filter('prettyUrl', PrettyUrl);

    function PrettyUrl() {
        return function (url) {
            if (url && url.charAt(url.length - 1) === '/') {
                url = url.slice(0, -1);                
            }

            return url;
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.components')
        .directive('scrollLock', ScrollLock);

    ScrollLock.$inject = ['$window'];

    function ScrollLock ($window) {
        return function (scope, element, attrs) {
            angular.element($window).bind('scroll', function () {
                if (this.pageYOffset >= attrs.fixedPosition) {
                    scope.vm.changeClass = true;
                } else {
                    scope.vm.changeClass = false;
                }
                scope.$apply();
            });
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.core')
        .config(AppConfig);

    AppConfig.$inject = [
        '$routeProvider',
        '$locationProvider',
        '$httpProvider',
        'adalAuthenticationServiceProvider'
        ];

    function AppConfig($routeProvider, $locationProvider, $httpProvider, adalAuthService) {

        $routeProvider
            .when('/login', {
                templateUrl: 'login.htm',
                controller: 'loginController',
                controllerAs: 'vm'
            })
            .when('/clientlist/', {
                templateUrl: 'clientlist.htm',
                controller: 'clientlistController',
                controllerAs: 'vm',
                requireADLogin: true
            })
            .when('/serverlist/', {
                templateUrl: 'serverlist.htm',
                controller: 'serverlistController',
                controllerAs: 'vm',
                requireADLogin: true
            })
            .when('/client/:id', {
                templateUrl: 'client.htm',
                controller: 'clientController',
                controllerAs: 'vm',
                requireADLogin: true
            })
            .when('/password/', {
                templateUrl: 'secret.htm',
                controller: 'secretController',
                controllerAs: 'vm',
                requireADLogin: true
            })
            .when('/server/:id/:clientId?', {
                templateUrl: 'server.htm',
                controller: 'serverController',
                controllerAs: 'vm',
                requireADLogin: true
            })
            .when('/sendgrid/', {
                templateUrl: 'sendgrid.htm',
                controller: 'sendgridController',
                controllerAs: 'vm',
                requireADLogin: true
            })
            .when('/crmsync/', {
                templateUrl: 'crmsync.htm',
                controller: 'crmsyncController',
                controllerAs: 'vm',
                requireADLogin: true
            })
            .when('/oidcmanifest/', {
                templateUrl: 'oidcmanifest.htm',
                controller: 'oidcmanifestController',
                controllerAs: 'vm',
                requireADLogin: true
            })
            .otherwise({
                redirectTo: 'login'
            });

        adalAuthService.init(
          {
            tenant: '776a75a9-3869-456f-a62a-29e443bc7397',
            clientId: '03bc4038-2d4c-4225-b832-567a28689242'
          },
          $httpProvider);

        $locationProvider.html5Mode(true).hashPrefix('!');
    }

}(angular));

(function (angular) {

    angular
        .module('app.core')
        .factory('datasource', Datasource);

    Datasource.$inject = ['$http'];

    function Datasource($http) {

        var SECRET_URL,
            SERVER_URL,
            SERVERLIST_URL,
            CLIENT_URL,
            CLIENTLIST_URL,
            TYPES_URL,
            GROUPS_URL,
            datasource,
            UNALLOCATEDACCOUNTLIST_URL,
            SENDGRID_REPUTATIONS_URL,
            MESSAGELIST_URL,
            SYNCCLIENTURL_URL,
            SYNCAllCLIENTURLS_URL,
            CLIENTISAMSURLS_URL;

        SECRET_URL = '/api/secret';
        SERVER_URL = '/api/server';
        SERVERLIST_URL = '/api/server/list';
        CLIENT_URL = '/api/client';
        CLIENTLIST_URL = '/api/clientlist';
        TYPES_URL = '/api/type';
        GROUPS_URL = '/api/group';
        UNALLOCATEDACCOUNTLIST_URL = 'api/accounts/unallocated';
        SENDGRID_REPUTATIONS_URL = 'api/sendgrid';
        MESSAGELIST_URL = "/api/crmsync/messages";
        SYNCCLIENTURL_URL = "/api/crmsync/clienturl/sync";
        SYNCAllCLIENTURLS_URL = "/api/crmsync/clienturl/syncAll";
        CLIENTISAMSURLS_URL = "/api/ClientIsamsUrl";

        datasource = {};

        datasource.getClients = function () {
            return $http.get(CLIENTLIST_URL);
        };

        datasource.getClient = function (id) {
            return $http.get(CLIENT_URL + '/' + id);
        };

        datasource.addClient = function (client) {
            return $http.post(CLIENT_URL, client);
        };

        datasource.updateClient = function (client) {
            return $http.put(CLIENT_URL, client);
        };

        datasource.deleteClient = function (id) {
            return $http.delete(CLIENT_URL + '/' + id);
        };

        datasource.getTypes = function () {
            return $http.get(TYPES_URL);
        };

        datasource.getGroups = function () {
            return $http.get(GROUPS_URL);
        };

        datasource.getSecret = function () {
            return $http.get(SECRET_URL);
        };

        datasource.addSecret = function (secret) {
            return $http.post(SECRET_URL, secret);
        };

        datasource.deleteSecret = function (version) {
            return $http.delete(SECRET_URL + '/?version=' + version);
        };

        datasource.getUnallocatedAccounts = function() {
            return $http.get(UNALLOCATEDACCOUNTLIST_URL);
        };

        datasource.getServer = function(id) {
            return $http.get(SERVER_URL + '/' + id);
        };

        datasource.getServerClients = function(id) {
            return $http.get(SERVER_URL + '/' + id + '/clients');
        };

        datasource.updateServer = function (server) {
            var payload = { server: server };
            return $http.put(SERVER_URL, payload);
        };
                
        datasource.getSendGridReputations = function() {
            return $http.get(SENDGRID_REPUTATIONS_URL);
        }

        datasource.getMessages = function (entityName) {
            if (entityName === "null" || entityName == null) {
                return $http.get(MESSAGELIST_URL);
            }

            return $http.get(MESSAGELIST_URL + "/" + entityName);
        };

        datasource.syncClientUrl = function (clientCode) {
            return $http.post(SYNCCLIENTURL_URL, JSON.stringify(clientCode));
        };

        datasource.syncAllClientUrls = function () {
            return $http.post(SYNCAllCLIENTURLS_URL);
        };

        datasource.getServers = function () {
            return $http.get(SERVERLIST_URL);
        };

        datasource.getClientIsamsUrls = function () {
            return $http.get(CLIENTISAMSURLS_URL);
        };

        return datasource;
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.crmsync')
        .controller('crmsyncController', CrmsyncController);

    CrmsyncController.$inject = [
        'datasource',
        'message',
        'dataTransferService',
        'rolesService'
    ];

    // eslint-disable-next-line sonarjs/cognitive-complexity
    function CrmsyncController(datasource, message,
        dataTransferService, rolesService) {

        var vm = this;

        vm.hasAccess = rolesService.hasRole('Contributor');
        vm.messages = [];
        vm.message = null;
        vm.clientCode = null;
        vm.showMessageList = true;
        vm.showSyncConfirmation = false;
        vm.showClientCodePrompt = false;
        vm.setEntity = setEntity;
        vm.forceSync = forceSync;
        vm.noSearchResults = noSearchResults;
        vm.entityName = dataTransferService.getData('entityName') || null;
        vm.syncClientUrl = syncClientUrl;
        vm.syncAllClientUrls = syncAllClientUrls;
        vm.cancel = refreshMessages;
        vm.refreshMessages = refreshMessages;
        vm.openSyncForm = openSyncForm;
        vm.openSyncAllForm = openSyncAllForm;
        vm.sync = sync

        vm.showbuttons = {
            syncSingle: vm.hasAccess,
            syncAll: vm.hasAccess
        };

        vm.entities = [
            { text: "All", value: null },
            { text: "Account", value: "AccountMessage" },
            { text: "Account URL", value: "AccountUrlMessage" },
            { text: "Server", value: "ClientServerMessage" },
            { text: "System", value: "System" }
        ];

        init();

        function init() {
            getMessages(true);
        }

        function sync() {
            if (vm.showSyncConfirmation) {
                vm.syncAllClientUrls();
            } else if (vm.showClientCodePrompt) {
                vm.syncClientUrl()
            } else {
                vm.refreshMessages()
            }
        }

        function openSyncForm() {
            vm.showMessageList = false;
            vm.showSyncConfirmation = false;
            vm.showClientCodePrompt = true;

            vm.showbuttons = {
                syncAction: true,
                cancel: true
            };
        }

        function openSyncAllForm() {
            vm.showMessageList = false;
            vm.showClientCodePrompt = false;
            vm.showSyncConfirmation = true;

            vm.showbuttons = {
                syncAction: true,
                cancel: true
            };
        }

        function getMessages(showSuccessMessage) {
            if (!vm.hasAccess) {
                return;
            }

            if (showSuccessMessage) {
                vm.message = message.show('Loading list of messages', 'info');
            }

            datasource
                .getMessages(vm.entityName)
                .success(function (data) {
                    vm.messages = angular.fromJson(data);

                    if (showSuccessMessage) {
                        vm.message = message.show(vm.messages.length + ' messages loaded.', 'ok');
                    }
                })
                .error(function (error) {
                    var msg;

                    if (!error.message) {
                        msg = 'Failed to connect to API.';
                    } else {
                        msg = 'Unable to load list of messages: ' + error.message;
                    }
                    vm.message = message.show(msg, 'error');
                });
        }

        function syncClientUrl() {
            datasource
                .syncClientUrl(vm.clientCode)
                .success(function (data) {
                    if (data) {
                        handlesyncSuccess('Client URL synced');
                    } else {
                        handleSyncError('Could not sync Client URL')
                    }
                })
                .error(function (error) {
                    if (!error.message) {
                        handleSyncError(CONNECTION_FAILED_MESSAGE);
                    } else {
                        handleSyncError('Could not sync Client URL: ' + error.message)
                    }
                });
        }

        function syncAllClientUrls() {
            datasource
                .syncAllClientUrls()
                .success(function () {
                    handlesyncSuccess('Client URLs synced');
                })
                .error(function (error) {
                    if (!error.message) {
                        handleSyncError(CONNECTION_FAILED_MESSAGE);
                    } else {
                        handleSyncError('Could not sync Client URLs: ' + error.message)
                    }
                });
        }

        function handleSyncError(msg) {
            vm.message = message.show(msg, 'error');
            vm.refreshMessages()
        }

        function handlesyncSuccess(msg) {
            vm.message = message.show(msg, 'ok');
            vm.refreshMessages()
        }

        function refreshMessages() {
            vm.showSyncConfirmation = false;
            vm.showClientCodePrompt = false;
            vm.showMessageList = true
            getMessages(false);

            vm.showbuttons = {
                syncSingle: vm.hasAccess,
                syncAll: vm.hasAccess
            };
        }

        function setEntity(entityName) {
            vm.entityName = entityName;
            getMessages(true);
        }

        function forceSync() {
            alert("Will force sync")
        }

        function noSearchResults() {
            if (!vm.hasAccess) {
                return false;
            }

            if (vm.messages == null || vm.messages.length == null) {
                return true;
            }

            return vm.messages.length === 0;
        }

    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.footer')
        .directive('footerBar', FooterBar);

    function FooterBar() {
        return {
            restrict: 'E',
            controller: FooterBarController,
            scope: {},
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'footer.htm'
        };
    }

    FooterBarController.$inject = ['datasource'];

    function FooterBarController(datasource) {
        var vm = this;

        vm.password = '';
        vm.havePassword = false;

        init();

        function init() {
            datasource
                .getSecret()
                .success(function (data) {
                    if (data && Array.isArray(data) && data.length > 0) {
                        vm.password = data[0].password;
                        vm.havePassword = true;

                    }
                });
        }
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.header')
        .directive('headerBar', HeaderBar);

    function HeaderBar() {
        return {
            restrict: 'E',
            templateUrl: 'header.htm'
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.login')
        .controller('loginController', LoginController);

    LoginController.$inject = [
                                '$location',
                                'adalAuthenticationService'
                            ];

    function LoginController ($location, adalAuthenticationService) {
        var vm = this;

        vm.login = login;
        vm.message = message;

        function message () {
            vm.error = null;
            if (adalAuthenticationService.loginError &&
                adalAuthenticationService.loginError !== '') {
                vm.error = adalAuthenticationService.loginError;
            }
        }

        function login() {
            $location.path('/clientlist/').replace();
        }
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.nav')
        .directive('navBar', NavBar);

    function NavBar() {
        return {
            restrict: 'E',
            controller: NavBarController,
            scope: {},
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'nav.htm'
        };
    }

    NavBarController.$inject = ['adalAuthenticationService', '$location', '$rootScope'];

    function NavBarController(adalAuthenticationService, $location, $rootScope) {
        var vm = this;
        vm.logout = logout;
        vm.userInfo = userInfo;
        vm.navToSecrets = navToSecrets;
        vm.navToClients = navToClients;
        vm.navToSendGrid = navToSendGrid;
        vm.navToCrmSync = navToCrmSync;
        vm.navToServers = navToServers;
        vm.navToOidcManifest = navToOidcManifest;

        function logout() {
            console.log('Logging out ...');
            adalAuthenticationService.logOut();
        }

        function userInfo() {
            return $rootScope.userInfo.profile.name || '';
        }

        function navToSecrets() {
            $location.path('password/').replace();
        }

        function navToClients() {
            $location.path('clientlist/').replace();
        }

        function navToSendGrid() {
            $location.path('sendgrid/').replace();
        }

        function navToCrmSync() {
            $location.path('crmsync/').replace();
        }

        function navToServers() {
            $location.path('serverlist/').replace();
        }

        function navToOidcManifest() {
            $location.path('oidcmanifest/').replace();
        }
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.oidcmanifest')
        .controller('oidcmanifestController', OidcmanifestController);

    OidcmanifestController.$inject = [
        'datasource',
        'rolesService'
    ];

    // eslint-disable-next-line sonarjs/cognitive-complexity
    function OidcmanifestController(datasource, rolesService) {

        var vm = this;

        vm.hasAccess = rolesService.hasRole('Contributor');
        vm.content = '';

        init();

        function init() {
            getData();
        }


        function getData() {
            if (!vm.hasAccess) {
                return;
            }

            datasource
                .getClientIsamsUrls()
                .success(function (data) {
                    var content = '"replyUrlsWithType": [\n';

                    var urls = angular.fromJson(data);

                    urls.push("isams.dev");
                    urls.push("*.local");
                    urls.push("*.groupportal.cloud");

                    urls.forEach(function (u) {
                        content += '\t{ "url": "https://' + u + '/auth/*", "type": "Web" },\n'
                    });

                    // remove trailling comma
                    content = content.substr(0, content.length - 2);

                    content += '\n],'
                    vm.content = content;
                });
        }
    }
}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.roles')
        .service('rolesService', RolesService);

    RolesService.$inject = ['$rootScope'];

    function RolesService($rootScope) {

        var hasRole,
            usersRoles;

        usersRoles = $rootScope.userInfo.profile.roles;

        hasRole = function (role) {
            if (usersRoles) {
                return usersRoles.indexOf(role) !== -1;
            }
            return false;
        };

        return {
            hasRole: hasRole
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.roles')
        .directive('userHasAccess', UserHasAccess);

    UserHasAccess.$inject = ['ngIfDirective', 'rolesService'];

    function UserHasAccess(ngIfDirective, rolesService) {
        var ngIf = ngIfDirective[0];

        return {
            transclude: ngIf.transclude,
            priority: ngIf.priority,
            terminal: ngIf.terminal,
            restrict: ngIf.restrict,
            link: function ($scope, $element, $attr) {
                var value;

                value = $attr.userHasAccess;

                $attr.ngIf = function () {
                    return rolesService.hasRole(value);
                };

                ngIf.link.apply(ngIf, arguments);
            }
        };
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.secret')
        .controller('secretController', SecretController);

    SecretController.$inject = [
        'datasource',
        'message',
        'rolesService'
        ];

    function SecretController(datasource, message, rolesService) {

        var vm = this;

        vm.message = message.show('Retrieving passwords', 'info');
        vm.passwords = [];
        vm.copied = false;
        vm.deleteVersion = deleteVersion;

        vm.addClient = addSecret;
        vm.cancel = cancelAdd;
        vm.saveClient = saveAdd;

        vm.showbuttons = {
            add: rolesService.hasRole('PasswordAdmin')
        };
        vm.add = {
            password: '',
            version: ''
        };
        vm.editView = false;

        init();

        function init() {
            datasource
                .getSecret()
                .success(function (data) {
                    vm.passwords = data;
                    vm.message = message.show('Retrieved passwords', 'ok');
                })
                .error(function () {
                    vm.message = message.show('Failed to retrieve passwords', 'error');
                });
        }

        function deleteVersion(version) {
            datasource
                .deleteSecret(version)
                .success(function () {
                    init();
                })
                .error(function () {
                    vm.message = message.show('Error deleting password', 'error');
                });
        }

        function addSecret() {
            vm.editView = true;
            vm.showbuttons.add = false;
        }

        function cancelAdd() {
            vm.editView = false;
            vm.showbuttons.add = true;
            vm.add = {
                password: '',
                version: ''
            };
        }

        function saveAdd() {

            if (!vm.add.password || vm.add.password === '') {
                vm.message = message.show('No password specified', 'error');
                return false;
            }

            if (!vm.add.version || vm.add.version === '') {
                vm.message = message.show('No iSAMS version specified', 'error');
                return false;
            }

            datasource
                .addSecret(vm.add)
                .success(function () {
                    vm.editView = false;
                    vm.showbuttons.add = true;
                    init();
                })
                .error(function () {
                    vm.message = message.show('Failed to add new password', 'error');
                });

            return true;
        }
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.sendgrid')
        .controller('sendgridController', SendGridController);

        SendGridController.$inject = ['datasource', 'message'];

    function SendGridController(datasource, message) {
        var vm = this;
        vm.message = message.show('Retrieving data ...', 'info');

        init();

        function init() {
            datasource
                .getSendGridReputations()
                .success(function (data) {
                    createChart(sanitiseData(data));
                    vm.message = message.show('Retrieved data', 'ok');
                })
                .error(function () {
                    vm.message = message.show('Failed to retrieve SendGrid Reputation data', 'error');
                });
        }

        function createChart(data) {
            var ctx = document.getElementById('chart').getContext('2d');
            new Chart(ctx, {
                type: 'line',            
                data: {
                    datasets: data
                },
                options: {
                    title: {
                        display: true,
                        text: 'Subuser Reputations',
                        fontSize: 16,
                        padding: 40
                    },
                    plugins: {
                        colorschemes: {                  
                            scheme: 'tableau.ClassicLight10'
                        }
                    },
                    legend: {
                        position: 'right'
                    },
                    scales: {
                        xAxes: [{
                            type: 'time',
                            distribution: 'linear',
                            time: {
                                unit: 'day'
                            }
                        }],
                        yAxes: [{
                            scaleLabel: {
                                display: true,
                                labelString: 'Score'
                            },
                            ticks: {
                                callback: function(value, index, values) {
                                    return value + '%';
                                }
                            }
                        }]
                    }
                }
            });        
        }

        function sanitiseData(data) {
            var datasets = [];
            var hash = {};
            data.sort(function(a, b) {
                var x = a.username.localeCompare(b.username);
                if(x === 0) {
                    x = a.timestamp.localeCompare(b.timestamp);
                }
                return x;
            });
            data.forEach(function(element) {
                var username = element.username.toLowerCase();
                if(!Array.isArray(hash[username])) {
                    hash[username] = [];
                }
                hash[username].push({t: element.timestamp.split('T')[0], y:element.reputation.toFixed(2)});
            });
            for (var key in hash) {
                if (hash.hasOwnProperty(key)) {
                    var dataPoints = hash[key];
                    datasets.push({
                        label: key,
                        fill: false,
                        data: dataPoints
                    });
                }
            }
            return datasets;
        }
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.server')
        .controller('serverController', ServerController);

    ServerController.$inject = [
        'datasource',
        '$routeParams',
        'message',
        '$location'
        ];

    function ServerController(datasource, $routeParams, message, $location) {

        var vm = this;
        vm.clientId = null;
        vm.server = {};
        vm.clients = [];
        vm.message = null;
        vm.backTo = backTo;
        vm.saveServer = saveServer;
        vm.navToClient = navToClient;

        init();

        function init() {

            var id = $routeParams.id;
            vm.clientId = $routeParams.clientId;
            console.log('client id: ' + vm.clientId);
            loadServer(id);
            loadClients(id);
        }

        function loadServer(id) {
            datasource
                .getServer(id)
                .success(function (data) {

                    vm.server = angular.fromJson(data);

                })
                .error(handleError);
        }

        function loadClients(id) {
            datasource
                .getServerClients(id)
                .success(function (data) {

                    vm.clients = angular.fromJson(data);

                })
                .error(handleError);
        }

        function backTo() {

            if (vm.clientId) {
                $location.url($location.path());
                $location.path('/client/' + vm.clientId).replace();
            } else {
                $location.url($location.path());
                $location.path('/serverlist').replace();
            }
        }

        function saveServer() {
            datasource
                .updateServer(vm.server)
                .success(function () {
                    backTo();
                })
                .error(handleError);
        }

        function handleError(error) {
            var msg;

            if (!error.message) {
                msg = 'Failed to connect to API.';
            } else {
                msg = 'Error occurred: ' + error.message;
            }
            vm.message = message.show(msg, 'error');
        }

        function navToClient(clientId) {
            vm.clientId = clientId;
            vm.backTo();
        }
    }

}(angular));

(function (angular) {
    'use strict';

    angular
        .module('app.serverlist')
        .controller('serverlistController', ServerlistController);

    ServerlistController.$inject = [
        'datasource',
        'message',
        '$location',
        'dataTransferService'
        ];

    // eslint-disable-next-line sonarjs/cognitive-complexity
    function ServerlistController (datasource, message, $location, dataTransferService) {

        var vm = this;

        vm.serverName = null;
        vm.servers = [];

        vm.message = message.show('Loading list of servers', 'info');

        vm.search = search;
        vm.startsWith = startsWith;
        vm.setLetter = setLetter;
        vm.showServer = showServer;
        vm.noSearchResults = noSearchResults;
        vm.clearSearch = clearSearch;
        vm.query = dataTransferService.getData('serverSearchValue');
        vm.letter = dataTransferService.getData('serverLetterValue') || '';

        vm.showbuttons = {
            add: false,
            edit: false
        };

        vm.alphabet = ['Hosted', 'a', 'b', 'c', 'd', 'e', 'f', 'g',
            'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p',
            'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

        init();

        function init() {
            datasource
                .getServers()
                .success(function (data) {
                    vm.servers = angular.fromJson(data);
                    vm.message = message.show(vm.servers.length + ' servers loaded.', 'ok');
                })
                .error(function (error) {
                    var msg;

                    if (!error.message) {
                        msg = 'Failed to connect to API.';
                    } else {
                        msg = 'Unable to load list of servers: ' + error.message;
                    }
                    vm.message = message.show(msg, 'error');
                });
        }

        function search(server) {
            function checkValue(val) {
                val = val || '';
                return (angular.lowercase(val).indexOf(angular.lowercase(vm.query) || '') !== -1);
            }

            return checkValue(server.name);
        }

        function startsWith(server) {
            if (vm.letter === '') {
                return true;
            }

            if (vm.letter === 'Hosted') {
                return server.isHosted;
            }

            return (angular.lowercase(server.name).indexOf(vm.letter) === 0);
        }

        function setLetter(letter) {
            vm.letter = (vm.letter === letter) ? '' : letter;
        }

        function showServer(id) {
            setSearch();
            $location.url($location.path());

            if (id) {
                $location.path('server/' + id).replace();

            } else if (vm.filteredServers.length > 0) {

                $location.path('server/' + vm.filteredServers[0].id).replace();
            }
        }

        function noSearchResults() {
            if (vm.filteredServers === undefined || vm.servers.length === 0) {
                return false;
            }
            return ((vm.filteredServers).length === 0);
        }

        function clearSearch() {
            vm.query = '';
            vm.letter = '';
        }

        function setSearch() {
            dataTransferService.setData('serverLetterValue', vm.letter);
            dataTransferService.setData('serverSearchValue', vm.query);
        }
    }

}(angular));

angular.module("app.templates").run(["$templateCache", function($templateCache) {$templateCache.put("autocomplete.htm","<input type=\"text\" maxlength=\"255\" ng-model=\"ctrl.autocomplete\" ng-keydown=\"ctrl.userAction($event)\" ng-blur=\"ctrl.setFocus(false)\" ng-focus=\"ctrl.setFocus(true)\" placeholder=\"{{ctrl.placeholder}}\"><ul ng-if=\"ctrl.showHints() && ctrl.focused\"><li class=\"autocomplete-hint\" ng-repeat=\"hint in ctrl.filteredHints | limitTo: 5\" ng-bind=\"hint\" ng-class=\"{selected: ctrl.selected === hint}\" ng-click=\"ctrl.chooseHint(hint)\"></li></ul>");
$templateCache.put("client.htm","<header-bar class=\"fixed\"></header-bar><ul class=\"client-information\"><li ng-if=\"vm.client.grouping\" ng-bind=\"vm.client.grouping\"></li><li ng-bind=\"vm.client.type | schoolType:this\"></li></ul><ul class=\"address\" ng-if=\"vm.addressBarShown == true\"><li ng-if=\"vm.checkState(vm.client.address.line1)\" ng-bind=\"vm.client.address.line1\"></li><li ng-if=\"vm.checkState(vm.client.address.line2)\" ng-bind=\"vm.client.address.line2\"></li><li ng-if=\"vm.checkState(vm.client.address.line3)\" ng-bind=\"vm.client.address.line3\"></li><li ng-if=\"vm.checkState(vm.client.address.town)\" ng-bind=\"vm.client.address.town\"></li><li ng-if=\"vm.checkState(vm.client.address.county)\" ng-bind=\"vm.client.address.county\"></li><li ng-if=\"vm.checkState(vm.client.address.postcode)\" ng-bind=\"vm.client.address.postcode\"></li><li ng-if=\"vm.checkState(vm.client.address.country)\" ng-bind=\"vm.client.address.country\"></li></ul><div class=\"header-spacer\" ng-class=\"{\'header-spacer-no-address\': vm.addressBarShown == false}\"></div><div scroll-lock fixed-position=\"1\" ng-class=\"{\'client-header-shadow\':vm.changeClass,\r\n    \'client-header-shadow-with-address\': vm.addressBarShown == true && vm.changeClass}\"></div><message-bar values=\"vm.message\"></message-bar><div class=\"client-section client-details\" ng-if=\"vm.editView\"><div ng-if=\"!vm.showDelete\"><h2>Populate From Central CRM</h2><select ng-model=\"vm.client.clientCode\" ng-options=\"account.clientCode as account.name for account in vm.crmAccounts\" ng-change=\"vm.crmAccountSelected()\"><option value=\"\">--- choose crm account ---</option></select></div><h2>Client Details</h2><input type=\"text\" ng-model=\"vm.client.name\" maxlength=\"255\" placeholder=\"Client Name\"><select ng-model=\"vm.client.type\" ng-options=\"type.id as type.name for type in vm.schooltypes\"></select><auto-complete hints=\"vm.groups\" value=\"vm.client.grouping\" placeholder=\"Client grouping\"></auto-complete></div><div class=\"client-section client-address\" ng-if=\"vm.editView\"><h2>Client Address</h2><input type=\"text\" ng-change=\"vm.showAddressBar()\" maxlength=\"255\" ng-model=\"vm.client.address.name\" placeholder=\"Name\"> <input type=\"text\" ng-change=\"vm.showAddressBar()\" maxlength=\"255\" ng-model=\"vm.client.address.line1\" placeholder=\"Address line 1\"> <input type=\"text\" ng-change=\"vm.showAddressBar()\" maxlength=\"255\" ng-model=\"vm.client.address.line2\" placeholder=\"Address line 2\"> <input type=\"text\" ng-change=\"vm.showAddressBar()\" maxlength=\"255\" ng-model=\"vm.client.address.line3\" placeholder=\"Address line 3\"> <input type=\"text\" ng-change=\"vm.showAddressBar()\" maxlength=\"255\" ng-model=\"vm.client.address.town\" placeholder=\"Town\"> <input type=\"text\" ng-change=\"vm.showAddressBar()\" maxlength=\"255\" ng-model=\"vm.client.address.county\" placeholder=\"County\"> <input type=\"text\" ng-change=\"vm.showAddressBar()\" maxlength=\"255\" ng-model=\"vm.client.address.postcode\" placeholder=\"Postcode\"> <input type=\"text\" ng-change=\"vm.showAddressBar()\" maxlength=\"255\" ng-model=\"vm.client.address.country\" placeholder=\"Country\"></div><div class=\"client-section\" ng-if=\"((vm.client.notes | filter:{deleted: false}).length > 0) || vm.editView\"><h2 ng-if=\"vm.editView\">Notes</h2><ul class=\"notes\" ng-class=\"{notedit:!vm.editView}\"><li ng-repeat=\"note in vm.client.notes\" ng-class=\"{\'new\': note.new}\" ng-if=\"note.deleted === false\"><span ng-if=\"!vm.editView\"><strong>{{note.type}}:&nbsp;</strong> {{note.text}} </span><input type=\"text\" maxlength=\"255\" ng-if=\"vm.editView\" ng-model=\"note.type\" placeholder=\"Title\"><textarea ng-model=\"note.text\" ng-if=\"vm.editView\" placeholder=\"Note\"></textarea><div class=\"delete-button\" ng-if=\"vm.editView\" ng-click=\"vm.deleteItem(note)\">Delete</div></li><li ng-if=\"vm.editView\"><div class=\"add-button\" ng-click=\"vm.addNote()\">Add note</div></li></ul></div><div class=\"client-section client-links\" ng-if=\"((vm.client.services | filter:{deleted: false}).length > 0) || vm.editView\"><h2>Links</h2><ul class=\"services\" ng-class=\"{\'edit-mode\': vm.editView}\"><li ng-repeat=\"service in vm.client.services\" ng-class=\"{\'new\': service.new}\" ng-if=\"service.deleted === false\"><span class=\"service-type-{{vm.resolveImageName(service)}} ctrl-c\" ng-if=\"!vm.editView\" data-ctrlc=\"{{service.url}}\">&nbsp; </span><a ng-href=\"{{service.url | isamsUrl:service}}\" ng-if=\"!vm.editView\" ng-bind=\"service.url\" target=\"_blank\"></a><select ng-if=\"vm.editView\" ng-model=\"service.type\" ng-init=\"service.type = service.type || vm.servicetypes[0].id\" ng-options=\"service.id as service.name for service in vm.servicetypes\"></select><input type=\"text\" maxlength=\"255\" ng-model=\"service.url\" ng-if=\"vm.editView\"><div class=\"delete-button\" ng-if=\"vm.editView\" ng-click=\"vm.deleteItem(service)\">Delete</div></li><li ng-if=\"vm.editView\"><div class=\"add-button\" ng-click=\"vm.addService()\">Add link</div></li></ul></div><div class=\"client-section\" ng-if=\"((vm.crmServers() | filter:{deleted: false}).length > 0) && !vm.editView\"><h2>Server Information</h2><table class=\"server\"><thead><tr><th>Name</th><th>Hosted</th><th>Address</th><th>IP Address</th><th>Username</th><th>Password</th><th>Domain</th><th></th></tr></thead><tbody><tr ng-repeat=\"server in vm.crmServers()\" ng-if=\"server.deleted === false\" ng-class=\"{ \'db\': server.serverType === \'Database\'}\"><td data-col=\"Name\"><div class=\"ctrl-c\"><span ng-bind=\"server.name || \'-\'\"></span></div></td><td data-col=\"IsHosted\"><span ng-if=\"server.isHosted\">Y</span> <span ng-if=\"!server.isHosted\">-</span></td><td data-col=\"Address\"><div><a ng-href=\"{{server.url}}\" ng-if=\"server.url && server.url.indexOf(\'http\') === 0\" ng-bind=\"server.url\" target=\"_blank\"></a> <span ng-if=\"server.url && server.url.indexOf(\'http\') === -1\" ng-bind=\"server.url\"></span> <span ng-if=\"!server.url\">-</span></div></td><td data-col=\"IP Address\"><div class=\"ctrl-c\"><span ng-if=\"server.ip\" ng-bind=\"server.ip\"></span> <span ng-if=\"!server.ip\">-</span></div></td><td data-col=\"Username\"><div class=\"ctrl-c\"><span ng-bind=\"server.username || \'-\'\"></span></div></td><td data-col=\"Password\"><div class=\"ctrl-c\"><span ng-bind=\"server.password || \'-\'\"></span></div></td><td data-col=\"Domain\"><div class=\"ctrl-c\"><span ng-bind=\"server.domain || \'-\'\"></span></div></td><td><div class=\"edit-button\" ng-click=\"vm.editServer(server.id)\">Edit</div></td></tr></tbody></table></div><div class=\"client-section\" ng-if=\"((vm.client.servers | filter:{deleted: false}).length > 0) || vm.editView\"><h2>Legacy Server Information</h2><table class=\"server\" ng-class=\"{\'edit-mode\': vm.editView}\"><thead><tr><th>Name</th><th>Address</th><th>IP Address</th><th>Username</th><th>Password</th><th>Domain</th></tr></thead><tbody><tr ng-repeat=\"server in vm.client.servers\" ng-class=\"{\'new\': server.new}\" ng-if=\"server.deleted === false\"><td data-col=\"Name\"><div an class=\"ctrl-c\" ng-if=\"!vm.editView\"><span ng-bind=\"server.name || \'-\'\"></span></div><input type=\"text\" maxlength=\"255\" ng-model=\"server.name\" ng-if=\"vm.editView\" placeholder=\"Name\"></td><td data-col=\"Address\"><div ng-if=\"!vm.editView\"><a ng-href=\"{{server.url}}\" ng-if=\"server.url && server.url.indexOf(\'http\') === 0\" ng-bind=\"server.url\" target=\"_blank\"></a> <span ng-if=\"server.url && server.url.indexOf(\'http\') === -1\" ng-bind=\"server.url\"></span> <span ng-if=\"!server.url\">-</span></div><input type=\"text\" maxlength=\"255\" ng-model=\"server.url\" ng-if=\"vm.editView\" placeholder=\"URL\"></td><td data-col=\"IP Address\"><div class=\"ctrl-c\" ng-if=\"!vm.editView\"><span ng-if=\"server.ip\" ng-bind=\"server.ip\"></span> <span ng-if=\"!server.ip\">-</span></div><input type=\"text\" maxlength=\"255\" ng-model=\"server.ip\" ng-if=\"vm.editView\" placeholder=\"IP Address\"></td><td data-col=\"Username\"><div class=\"ctrl-c\" ng-if=\"!vm.editView\"><span ng-bind=\"server.username || \'-\'\"></span></div><input type=\"text\" maxlength=\"255\" ng-model=\"server.username\" ng-if=\"vm.editView\" placeholder=\"Username\"></td><td data-col=\"Password\"><div class=\"ctrl-c\" ng-if=\"!vm.editView\"><span ng-bind=\"server.password || \'-\'\"></span></div><input type=\"text\" maxlength=\"255\" ng-model=\"server.password\" ng-if=\"vm.editView\" placeholder=\"Password\"></td><td data-col=\"Domain\"><div class=\"ctrl-c\" ng-if=\"!vm.editView\"><span ng-bind=\"server.domain || \'-\'\"></span></div><input type=\"text\" maxlength=\"255\" ng-model=\"server.domain\" ng-if=\"vm.editView\" placeholder=\"Domain\"><div class=\"delete-button\" ng-if=\"vm.editView\" ng-click=\"vm.deleteItem(server)\">Delete</div></td></tr></tbody></table><div class=\"add-button\" ng-if=\"vm.editView\" ng-click=\"vm.addServer()\">Add server</div></div><div class=\"delete-client-button\" ng-class=\"{\'confirm\': vm.setForDelete == true}\" ng-if=\"vm.editView && vm.showDelete\" ng-click=\"vm.deleteClient()\"><span>Delete client</span> <span>Click to confirm?</span></div><footer-bar></footer-bar>");
$templateCache.put("clientlist.htm","<header-bar></header-bar><div class=\"search-bar\" scroll-lock fixed-position=\"100\" ng-class=\"{fixed:vm.changeClass}\"><input type=\"text\" placeholder=\"Type here to search...\" ng-enter=\"vm.showClient()\" ng-model=\"vm.query\" autofocus><div class=\"search-bar-clear\" ng-click=\"vm.clearSearch()\">clear</div></div><div class=\"letters-bar\" scroll-lock fixed-position=\"100\" ng-class=\"{fixed:vm.changeClass}\"><ul><li ng-repeat=\"letter in vm.alphabet\" ng-bind=\"letter\" ng-class=\"{\'selected\': letter === vm.letter}\" ng-click=\"vm.setLetter(letter)\"></li></ul></div><message-bar values=\"vm.message\"></message-bar><div class=\"clientlist-header-shadow\"></div><div class=\"no-results\" ng-class=\"{\'shown\' : vm.noSearchResults()}\">No results found</div><table class=\"responsive clientlist-table\"><tbody><tr ng-repeat=\"client in vm.filteredClients = (vm.clients | filter: vm.search | filter: vm.startsWith)\"><td data-column=\"name\" ng-click=\"vm.showClient(client.id)\">{{client.name}} <span class=\"clientlist-testsystem\" ng-if=\"client.testSystem\">[Test System]</span></td><td data-column=\"clientCode\" ng-click=\"vm.showClient(client.id)\" ng-bind=\"client.clientCode\"></td><td data-column=\"group\" ng-click=\"vm.showClient(client.id)\" ng-bind=\"client.grouping\"></td><td data-column=\"url\"><a ng-href=\"{{client.url | isamsUrl:client}}\" ng-bind=\"client.url | prettyUrl\" target=\"_blank\"></a></td></tr></tbody></table><footer-bar></footer-bar>");
$templateCache.put("crmsync.htm","<header-bar></header-bar><div class=\"entities-bar\" scroll-lock fixed-position=\"100\" ng-class=\"{fixed:vm.changeClass}\"><ul><li ng-repeat=\"entity in vm.entities\" ng-bind=\"entity.text\" ng-class=\"{\'selected\': entity.value === vm.entityName}\" ng-click=\"vm.setEntity(entity.value)\"></li></ul></div><message-bar values=\"vm.message\"></message-bar><div class=\"no-results\" ng-class=\"{\'shown\' : vm.noSearchResults()}\">No results found</div><div class=\"no-access\" ng-if=\"vm.hasAccess == false\">Contributor rights are required to view this data</div><table ng-if=\"vm.showMessageList && vm.hasAccess\" class=\"responsive crmsync-table\"><tbody><tr ng-repeat=\"message in vm.messages\"><td width=\"200\" data-column=\"entity\" ng-bind=\"message.entity\"></td><td data-column=\"message\" ng-bind=\"message.message\"></td><td width=\"200\" data-column=\"eventTime\" ng-bind=\"message.eventTime\"></td></tr></tbody></table><div class=\"client-section\" ng-if=\"vm.showClientCodePrompt\"><h2>Client Code</h2><p class=\"description\">Please enter the Client Code of the URL you wish to sync.</p><input type=\"text\" ng-model=\"vm.clientCode\" maxlength=\"50\" placeholder=\"Client Code\"></div><div class=\"client-section\" ng-if=\"vm.showSyncConfirmation\"><h2>Sync All</h2><p class=\"description\">You are about to send the iSAMS URL for every Client to the Central Service Bus. Please confirm that you wish to continue.</p></div>");
$templateCache.put("footer.htm","<footer><span class=\"ctrl-c\" data-ctrlc=\"{{vm.password}}\" ng-show=\"vm.havePassword\">Latest Admin Password</span></footer>");
$templateCache.put("header.htm","<nav-bar></nav-bar><header ng-class=\"{\'logo\' : !vm.client.name}\"><span class=\"back-button\" ng-class=\"{\'shown\' : vm.client.name}\" ng-click=\"vm.listView()\">&lsaquo;</span><h1 ng-bind=\"vm.clientTitle()\"></h1><div class=\"action-button add\" user-has-access=\"Contributor\" ng-click=\"vm.addClient()\" ng-class=\"{\'shown\': vm.showbuttons.add}\">Add</div><div class=\"action-button edit\" user-has-access=\"Contributor\" ng-click=\"vm.toggleEditView()\" ng-class=\"{\'shown\': vm.showbuttons.edit}\">Edit</div><div class=\"action-button cancel\" user-has-access=\"Contributor\" ng-click=\"vm.cancel()\" ng-class=\"{\'shown\': vm.editView || vm.showbuttons.cancel}\">Cancel</div><div class=\"action-button save\" user-has-access=\"Contributor\" ng-click=\"vm.saveClient()\" ng-class=\"{\'shown\': vm.editView}\">Save</div><div class=\"action-button sync-single\" user-has-access=\"Contributor\" ng-click=\"vm.openSyncForm()\" ng-class=\"{\'shown\': vm.showbuttons.syncSingle}\">Sync Single URL</div><div class=\"action-button sync-all\" user-has-access=\"Contributor\" ng-click=\"vm.openSyncAllForm()\" ng-class=\"{\'shown\': vm.showbuttons.syncAll}\">Sync all URLs</div><div class=\"action-button sync-action\" user-has-access=\"Contributor\" ng-click=\"vm.sync()\" ng-class=\"{\'shown\': vm.showbuttons.syncAction}\">Sync</div></header>");
$templateCache.put("login.htm","<div class=\"login\"><div class=\"login-logo\"><div class=\"login-button\" ng-click=\"vm.login()\">login</div><span class=\"login-text\" ng-bind=\"vm.error\" ng-if=\"vm.error\"></span></div></div>");
$templateCache.put("messagebar.htm","<div class=\"message-bar {{messagebar.status}}\" ng-class=\"{shown:messagebar.shown}\" ng-click=\"messagebar = message.hide()\">{{messagebar.text}}</div>");
$templateCache.put("nav.htm","<div class=\"nav-bar\"><span class=\"link\" ng-click=\"vm.navToClients()\">Clients</span> <span class=\"link\" ng-click=\"vm.navToServers()\">CRM Servers</span><!-- todo::asw::need to reduce this to the proper subset of people once trainiong are sorted <span class=\"link\" user-has-access=\"Contributor\" ng-click=\"vm.navToSecrets()\">Admin Password</span>--> <span class=\"link\" ng-click=\"vm.navToSecrets()\">Admin Password</span> <span class=\"link\" ng-click=\"vm.navToSendGrid()\">SendGrid Monitoring</span> <span class=\"link\" ng-click=\"vm.navToCrmSync()\">Central CRM Sync</span> <span class=\"link\" ng-click=\"vm.navToOidcManifest()\">OIDC Manifest</span> <span ng-bind=\"vm.userInfo()\"></span>, <span class=\"link\" ng-click=\"vm.logout()\">logout</span></div>");
$templateCache.put("oidcmanifest.htm","<header-bar></header-bar><pre>\r\n    {{vm.content}}\r\n</pre>");
$templateCache.put("secret.htm","<header-bar></header-bar><message-bar values=\"vm.message\"></message-bar><p>Click on the iSAMS Version number to copy the password to your clipboard.</p><div ng-if=\"!vm.editView\" class=\"passwordVersions\"><span ng-repeat=\"password in vm.passwords | orderBy:\'-Version\' \"><span class=\"ctrl-c\" data-ctrlc=\"{{password.password}}\">{{password.version}}</span><!-- todo::asw this needs to be admin only when that perm comes along --> <span user-has-access=\"PasswordAdmin\" ng-click=\"vm.deleteVersion(password.version)\">[Delete]</span></span></div><div class=\"client-section client-details\" ng-if=\"vm.editView\"><h2>New Admin Password</h2><input type=\"text\" ng-model=\"vm.add.version\" maxlength=\"255\" placeholder=\"iSAMS Version\"> <input type=\"text\" ng-model=\"vm.add.password\" maxlength=\"255\" placeholder=\"Password\"></div><div class=\"client-section client-details instructions\"><h2>Client Certificate Authentication Instructions</h2><p>The Administrator Account is protected using Client Certificate Authentication. The iSAMS instance must be on v22.1.28.7 or higher to login. When entering the administrator credentials, you will see a popup window asking you to select a certificate. The \"networkadmins@isams.co.uk [GlobalSign GCC R3 PersonalSign 1CA 2020]\" certificate should be selected.</p><img src=\"/assets/img/client-certificate-selection.png\" alt=\"Client Certificate Selection\"><p>After selecting the correct certificate, you will be taken to the 2FA verification process and can continue to login as normal.</p><p>If the certificate is not presented, or an invalid certificate is selected, the following login restricted message will be displayed.</p><img src=\"/assets/img/client-certificate-restricted.png\" alt=\"Client Certificate Restricted\"><h3>Known Issues</h3><ul><li>Client Certificate Authentication will not work if a Proxy is in use, such as Cloudflare in Proxy Mode. The certificate selection popup will not appear. To determine if Cloudflare Proxy is in use:<ol><li>Obtain the iSAMS domain. For example: developerdemo.isams.cloud</li><li>Open a command prompt on your machine</li><li>Perform an nslookup against the domain. For example: nslookup developerdemo.isams.cloud</li><li>If cloudflare is in use, the resulting name will contain cloudflare. Local Login must then be used.</li></ol></li><li>Client Certificate Authentication does not work in Firefox without having the certificate manually imported. Contact Network Support to have this configured.</li><li>Client Certificate Authentication does not work through Browserstack. The following workflow must be used:<ol><li>Obtain your IP address</li><li>Login to the iSAMS instance</li><li>Add your IP as a Trusted Network</li><li>Test through Browserstack using Local Testing</li><li>Remove your IP from Trusted Networks</li></ol></li></ul><p>If you experience any additional problems with the login, please post to the Dev-Auth channel. For more information, see the <a href=\"https://dev.azure.com/isams/iSAMS/_wiki/wikis/iSAMS.wiki/409/Administrator-Login-Restrictions\" target=\"_blank\">Administrator Login Restrictions Wiki.</a></p></div>");
$templateCache.put("sendgrid.htm","<header-bar></header-bar><message-bar values=\"vm.message\"></message-bar><canvas id=\"chart\"></canvas>");
$templateCache.put("server.htm","<nav-bar></nav-bar><header><span class=\"back-button shown\" ng-click=\"vm.backTo()\">&lsaquo;</span><h1 ng-bind=\"vm.server.name\"></h1><div class=\"action-button cancel shown\" user-has-access=\"Contributor\" ng-click=\"vm.backTo()\">Cancel</div><div class=\"action-button save shown\" user-has-access=\"Contributor\" ng-click=\"vm.saveServer()\">Save</div></header><message-bar values=\"vm.message\"></message-bar><div class=\"client-section\"><h2>Server Information</h2><table class=\"server edit-mode\"><thead><tr><th>Name</th><th>Hosted</th><th>Address</th><th>IP Address</th><th>Username</th><th>Password</th><th>Domain</th><th>Timezone</th></tr></thead><tbody><tr><td data-col=\"Name\"><div an class=\"ctrl-c\"><span ng-bind=\"vm.server.name || \'-\'\"></span></div></td><td data-col=\"IsHosted\"><span ng-if=\"vm.server.isHosted\">Y</span> <span ng-if=\"!vm.server.isHosted\">-</span></td><td data-col=\"Address\"><input type=\"text\" maxlength=\"255\" ng-model=\"vm.server.url\" placeholder=\"URL\"></td><td data-col=\"IP Address\"><input type=\"text\" maxlength=\"255\" ng-model=\"vm.server.ip\" placeholder=\"IP Address\"></td><td data-col=\"Username\"><input type=\"text\" maxlength=\"255\" ng-model=\"vm.server.username\" placeholder=\"Username\"></td><td data-col=\"Password\"><input type=\"text\" maxlength=\"255\" ng-model=\"vm.server.password\" placeholder=\"Password\"></td><td data-col=\"Domain\"><input type=\"text\" maxlength=\"255\" ng-model=\"vm.server.domain\" placeholder=\"Domain\"></td><td data-col=\"Timezone\"><input type=\"text\" maxlength=\"255\" ng-model=\"vm.server.timezone\" placeholder=\"Timezone\"></td></tr></tbody></table></div><div class=\"client-section\"><h2>Clients On This Server</h2><ul><li ng-repeat=\"client in vm.clients\"><span ng-click=\"vm.navToClient(client.id)\" class=\"clickable\"><span ng-bind=\"client.name\"></span>&nbsp;(<span ng-bind=\"client.clientCode\"></span>)</span></li></ul></div>");
$templateCache.put("serverlist.htm","<header-bar></header-bar><div class=\"search-bar\" scroll-lock fixed-position=\"100\" ng-class=\"{fixed:vm.changeClass}\"><input type=\"text\" placeholder=\"Type here to search...\" ng-enter=\"vm.showServer()\" ng-model=\"vm.query\" autofocus><div class=\"search-bar-clear\" ng-click=\"vm.clearSearch()\">clear</div></div><div class=\"letters-bar\" scroll-lock fixed-position=\"100\" ng-class=\"{fixed:vm.changeClass}\"><ul><li ng-repeat=\"letter in vm.alphabet\" ng-bind=\"letter\" ng-class=\"{\'selected\': letter === vm.letter}\" ng-click=\"vm.setLetter(letter)\"></li></ul></div><message-bar values=\"vm.message\"></message-bar><div class=\"clientlist-header-shadow\"></div><div class=\"no-results\" ng-class=\"{\'shown\' : vm.noSearchResults()}\">No results found</div><table class=\"responsive clientlist-table\"><tbody><tr ng-repeat=\"server in vm.filteredServers = (vm.servers | filter: vm.search | filter: vm.startsWith)\"><td data-column=\"name\" ng-click=\"vm.showServer(server.id)\">{{server.name}}</td><td data-column=\"ip\" ng-bind=\"server.ip\"></td><td data-column=\"domain\" ng-bind=\"server.domain\"></td><td data-column=\"timezone\" ng-bind=\"server.timezone\"></td></tr></tbody></table>");}]);